export default __webpack_public_path__ + "static/press-release-milan-laser-hair-removal-announces-new-COO-d8c78aecf9db71ed011f370810e2faf9.pdf";